import TooltipsMixin from "VueMixins/TooltipsMixin";

import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);
VeeValidate.config.fieldsBagName = "veeFields";

export default {
  mixins: [TooltipsMixin],
  data() {
    return {
      customers: [],
      selected_customer: null,
      redirect: null,
    };
  },
  beforeMount() {
    if (!this.customers?.length) {
      axios.get('/api/v1/admin/customer').then((response) => {
        this.customers = response.data.data;
      });
    }
  },
  methods: {
    customerSelected() {
      this.redirect.customer_slug = this.selected_customer.slug;
      this.selected_customer = null;
    },
  },
};
